import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, inject } from '@angular/core';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { MinibasketComponent } from '../../../basket/minibasket/minibasket.component';
import { MinibasketFastCheckoutFormComponent } from '../../../checkout/fast/minibasket-fast-checkout-form.component';
import { ActionComponent } from '../../../ui/api/action.component';
import { ResultComponent } from '../../../ui/api/result.component';
import { WishlistMoveFromBasketComponentDef } from './wishlist-move-from-basket.component.def';

@Component({
    selector: 'wishlist-move-from-basket',
    templateUrl: './wishlist-move-from-basket.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [ActionComponent, CommonModule, ResultComponent, TranslatePipe]
})
export class WishlistMoveFromBasketComponent extends WishlistMoveFromBasketComponentDef implements OnChanges {
    @Input()
    displayLabel = false;

    moved = false;

    private minibasketComponent = inject(MinibasketComponent, { optional: true });

    protected minibasketFastCheckoutForm = inject(MinibasketFastCheckoutFormComponent, { optional: true });

    ngOnChanges(changes: SimpleChanges) {
        if (changes['displayLabel']) {
            this._ref.detectChanges();
        }
    }

    onSuccess = () => {
        this.moved = true;
        this.minibasketComponent?.showMoveToWishlistNotification();

        this.minibasketFastCheckoutForm?.showMoveToWishlistNotification();

        this._ref.detectChanges();
    };
}
